export const GET_NOTIFICATION_TEMPLATE = 'GET_NOTIFICATION_TEMPLATE';
export const SUCCESS_GET_NOTIFICATION_TEMPLATE = 'SUCCESS_GET_NOTIFICATION_TEMPLATE';
export const FAIL_GET_NOTIFICATION_TEMPLATE = 'FAIL_GET_NOTIFICATION_TEMPLATE';

export const GET_NOTIFICATION_TEMPLATES = 'GET_NOTIFICATION_TEMPLATES';
export const SUCCESS_GET_NOTIFICATION_TEMPLATES = 'SUCCESS_GET_NOTIFICATION_TEMPLATES';
export const FAIL_GET_NOTIFICATION_TEMPLATES = 'FAIL_GET_NOTIFICATION_TEMPLATES';

export const INIT_NOTIFICATION_TEMPLATE = 'INIT_NOTIFICATION_TEMPLATE';
export const EDIT_NOTIFICATION_TEMPLATE = 'EDIT_NOTIFICATION_TEMPLATE';

export const VALIDATE_NOTIFICATION_TEMPLATE = 'VALIDATE_NOTIFICATION_TEMPLATE';
export const SUCCESS_VALIDATE_NOTIFICATION_TEMPLATE = 'SUCCESS_VALIDATE_NOTIFICATION_TEMPLATE';
export const FAIL_VALIDATE_NOTIFICATION_TEMPLATE = 'FAIL_VALIDATE_NOTIFICATION_TEMPLATE';

export const CREATE_NOTIFICATION_TEMPLATE = 'CREATE_NOTIFICATION_TEMPLATE';
export const SUCCESS_CREATE_NOTIFICATION_TEMPLATE = 'SUCCESS_CREATE_NOTIFICATION_TEMPLATE';
export const FAIL_CREATE_NOTIFICATION_TEMPLATE = 'FAIL_CREATE_NOTIFICATION_TEMPLATE';

export const UPDATE_NOTIFICATION_TEMPLATE = 'UPDATE_NOTIFICATION_TEMPLATE';
export const SUCCESS_UPDATE_NOTIFICATION_TEMPLATE = 'SUCCESS_UPDATE_NOTIFICATION_TEMPLATE';
export const FAIL_UPDATE_NOTIFICATION_TEMPLATE = 'FAIL_UPDATE_NOTIFICATION_TEMPLATE';

export const DELETE_NOTIFICATION_TEMPLATE = 'DELETE_NOTIFICATION_TEMPLATE';
export const SUCCESS_DELETE_NOTIFICATION_TEMPLATE = 'SUCCESS_DELETE_NOTIFICATION_TEMPLATE';
export const FAIL_DELETE_NOTIFICATION_TEMPLATE = 'FAIL_DELETE_NOTIFICATION_TEMPLATE';
